import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Navbar from "../common/Navbar";
import Footer from "../common/Footer";
import { emailVerification } from "../../actions/authActions";

class EmailVerification extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showMessage: "",
    };

  }

  componentDidMount = () => {
    const code = this.props.match.params.code;
    const sign = this.props.match.params.sign;

    if (code && sign) {
      this.props.emailVerification({code, sign});
    } else {
      this.props.history.push("/members");
    }
  };

  componentDidUpdate(prevProps) {
    if (this.props.errors !== prevProps.errors) {
      this.setState({ showMessage: this.props.errors.msg });
    }

    if (this.props.result !== prevProps.result) {
      if (this.props.result.msg && this.props.result.msg === "Email Verification OK") {
        this.setState({ showMessage: "您的 E-mail 已完成驗證" });
      }
    }
  };

  render() {
    const { showMessage } = this.state;

    return (
      <Fragment>
        <div id="page">
          <Navbar />
          <aside className="colorlib-breadcrumbs">
            <div className="container">
                <div className="row">
                    <div className="col-md-12 breadcrumbs text-center">
                        <h2>E-Mail 驗證</h2>
                        <p><span>Member Information</span></p>
                    </div>
                </div>
            </div>
          </aside>
          <div className="colorlib">
            <div className="container">
              <div className="details">
                <div className="collapse show" style={{borderRadius: "15px"}}>
                    <p style={{textAlign: "center", fontSize: "1.8rem" }}>{showMessage}</p>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </Fragment>
    );
  }
}

EmailVerification.propTypes = {
  emailVerification: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  errors: state.errors,
  result: state.auth.emailVerificationResult
});

export default connect(mapStateToProps, { emailVerification })(EmailVerification);